import { render } from "./AccessDenied.vue?vue&type=template&id=135f3ad2&scoped=true"
const script = {}

import "./AccessDenied.vue?vue&type=style&index=0&id=135f3ad2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135f3ad2"]])

export default __exports__